import "core-js/modules/es6.object.assign";
export { selectable } from './decorators/selectable';
export { sortable } from './decorators/sortable';
export { cellActions } from './decorators/cellActions';
export { cellWidth } from './decorators/cellWidth';
export { editable } from './decorators/editable';
export { breakWord, fitContent, nowrap, truncate, wrappable } from './decorators/wrappable';
export { textCenter } from './decorators/textCenter';
export { collapsible, expandedRow, expandable } from './decorators/collapsible';
export { compoundExpand } from './decorators/compoundExpand';
export { headerCol } from './decorators/headerCol';
export { classNames, Visibility } from './decorators/classNames';

var emptyTD = function emptyTD() {
  return {
    scope: '',
    component: 'td'
  };
};

var scopeColTransformer = function scopeColTransformer() {
  return {
    scope: 'col'
  };
};

var emptyCol = function emptyCol(label) {
  return Object.assign({}, label ? {} : {
    scope: ''
  });
};

var parentId = function parentId(_value, _ref) {
  var rowData = _ref.rowData;
  return {
    parentId: rowData.parent
  };
};

var mapProps = function mapProps(_label, _ref2) {
  var property = _ref2.property,
      rowData = _ref2.rowData;
  return Object.assign({}, rowData[property] && rowData[property].props);
};

export { emptyTD, scopeColTransformer, emptyCol, parentId, mapProps };